/**
 * Report Settings Service
 * Handles per-organization PDF report settings
 */

import axiosInstance, { apiRequest } from '../axiosInstance';
import { REPORT_SETTINGS_ENDPOINTS } from '../endpoints';

const reportSettingsService = {
  /**
   * Get effective report settings for current organization
   * @returns {Promise<Object>} ReportSettingsDto
   */
  getSettings: async () => {
    return apiRequest(() =>
      axiosInstance.get(REPORT_SETTINGS_ENDPOINTS.GET)
    );
  },

  /**
   * Update report settings for current organization
   * @param {Object} settings - ReportSettingsDto
   * @returns {Promise<Object>} Updated ReportSettingsDto
   */
  updateSettings: async (settings) => {
    return apiRequest(() =>
      axiosInstance.put(REPORT_SETTINGS_ENDPOINTS.UPDATE, settings)
    );
  },
};

export default reportSettingsService;
